module.exports = "/_next/static/images/NYSLeft-9f0c055540215161ef34214a4cdf7c2e.png";